import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Provider } from 'react-redux'
import { Bounce, ToastContainer } from 'react-toastify'
// import { ThemeProvider, createTheme } from '@mui/material'

import '../styles/main.css'
import 'react-toastify/dist/ReactToastify.css'

import AuthWrapper from './AuthWrapper'
import Homepage from './Homepage'
import Register from './Register'
import SupportPage from './Support'

// Programs Landing Pages
import AnayaCarePage from './Programs/AnayaCare'
import BilypsaCarePage from './Programs/BilypsaCare'
import ProstateCarePage from './Programs/ProstateCare'
import LiverForeverProgramPage from './Programs/LiverForeverProgramPage'
import AkumentisCarePage from './Programs/AkumentisCare'
import ViemaxProgramPage from './Programs/ViemaxProgramPage'
// Signup Pages
import SignupUser from './SignupUser/SignupUser'
import SignupSuccess from './SignupUser/SignupSuccess'

// Invalid Page
import InvalidPage from './InvalidPage'

// Care Plans Landing Pages
import LiverForeverCarePlanPage from './CarePlans/LiverForeverCarePlanPage/LiverForeverCarePlanPage'
import UploadDocumentsPage from './CarePlans/UploadDocumentsPage/UploadDocumentsPage'

import { persistor, store } from '../store'
import LiverForeverJourneyPage from './CarePlans/LiverForeverCarePlanPage/LiverForeverJourneyPage/LiverForeverJourneyPage'
import LiverForeverPreviewPage from './CarePlans/LiverForeverCarePlanPage/LiverForeverPreviewPage/LiverForeverPreviewPage'
import LiverForeverPlanAssignedPage from './CarePlans/LiverForeverCarePlanPage/LiverForeverPlanAssignedPage/LiverForeverPlanAssignedPage'
import LiverForeverPlanStatusPage from './CarePlans/LiverForeverCarePlanPage/LiverForeverPlanStatusPage/LiverForeverPlanStatusPage'
import { PersistGate } from 'redux-persist/integration/react'
import UserProfileDetails from './SignupUser/UserProfileDetails'
import ViemaxRoutes from './ViemaxProgram/Pages'
import AnayaCareRoutes from './AnayaCare/Pages'
import { DiasensRoutes } from './Diasens'
import { GlucoliveRoutes } from './Glucolive'
import { getCgmTypeFromHostname } from '../utils/helpers/cgmHostname'
import constants from '../constants'
import CustomThemeHandlerProvider from './CustomThemeHandlerProvider/index'
import BlockerScreen from '../components/BlockerScreen'
import SemaGlutideRoutes from './SemaGlutide/Pages/SemaPages.routes'

const CgmOnboardingRoutes = () => {
  const cgmType = getCgmTypeFromHostname()
  if (cgmType === constants.CGM_TYPE.GLUCOLIVE) {
    return <GlucoliveRoutes />
  }
  return <DiasensRoutes />
}

const AppRoutes = () => {
  // const theme = createTheme({
  //   palette: {
  //     primary: {
  //       main: '#8C2FDF',
  //     },
  //     secondary: {
  //       main: '#54595F',
  //     },
  //   },
  // })
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <CustomThemeHandlerProvider>
          <Router>
            <Routes>
              <Route path="/register" Component={Register} />
              <Route path="/support" Component={SupportPage} />
              <Route path="/programs/anaya-care" Component={AnayaCarePage} />
              <Route
                path="/programs/bilypsa-care"
                Component={BilypsaCarePage}
              />
              <Route
                path="/programs/prostate-care"
                Component={ProstateCarePage}
              />
              <Route
                path="/programs/liver-forever-program"
                Component={LiverForeverProgramPage}
              />
              <Route
                path="/programs/akumentis-care"
                Component={AkumentisCarePage}
              />

              {/* PSP Signup Routes */}
              <Route path="/psp/signup-user" Component={SignupUser} />
              <Route path="/psp/signup-success" Component={SignupSuccess} />

              {/* CGM Signup Routes (GoodFlip/Diasens) */}
              <Route path="/signup-user" Component={SignupUser} />
              <Route path="/signup-success" Component={SignupSuccess} />

              <Route
                path="/care-plans/liver-forever-program"
                Component={AuthWrapper(LiverForeverCarePlanPage)}
              />
              <Route
                path="/care-plans/liver-forever-program/journey"
                Component={AuthWrapper(LiverForeverJourneyPage)}
              />
              <Route
                path="/care-plans/liver-forever-program/preview"
                Component={AuthWrapper(LiverForeverPreviewPage)}
              />
              <Route
                path="/care-plans/liver-forever-program/plan-status"
                Component={AuthWrapper(LiverForeverPlanStatusPage)}
              />
              <Route
                path="/care-plans/liver-forever-program/plan-assigned"
                Component={AuthWrapper(LiverForeverPlanAssignedPage)}
              />
              <Route
                path="/care-plans/upload-documents"
                Component={AuthWrapper(UploadDocumentsPage)}
              />
              <Route
                path="/programs/viemax-program"
                Component={ViemaxProgramPage}
              />

              {/* Viemax Care Plan Routes */}
              <Route
                path="/care-plans/viemax-program/*"
                Component={AuthWrapper(ViemaxRoutes)}
              />
              <Route
                path="/care-plans/anaya-care/*"
                Component={AuthWrapper(AnayaCareRoutes)}
              />

              {/* CGM Onboarding Routes (Diasens / GoodFlip / GlucoLive) */}
              <Route path="/onboarding/*" Component={CgmOnboardingRoutes} />
              <Route path="/cgm/*" Component={CgmOnboardingRoutes} />

              {/* Sema Glutide Routes */}
              <Route path="/:variant?/*" Component={SemaGlutideRoutes} />

              {/* NOTE: For Every new PSPs we need to create a standalone file where we can put all the routes for that PSP
              Refer ViemaxProgram/Pages/index.js for reference */}

              <Route path="/" Component={InvalidPage} />
              <Route path="/blocked" Component={BlockerScreen} />
            </Routes>
          </Router>
        </CustomThemeHandlerProvider>
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          transition={Bounce}
        />
      </PersistGate>
    </Provider>
  )
}

export default AppRoutes
